import { createIcon } from './_icon';

const BellOutlinedIcon = createIcon(() => (
	<svg width="1em" height="1em" fill="none" viewBox="0 0 24 24">
		<path
			stroke="currentColor"
			stroke-width="2"
			d="M8.22 18.5C8.976 19.994 10.386 21 12 21c1.615 0 3.025-1.006 3.78-2.5M20 18l-1.207-9.053a6.853 6.853 0 0 0-13.586 0L4 18h16Z"
		/>
	</svg>
));

export default BellOutlinedIcon;
